<!-- 3D軌跡 プレイヤーコンポーネント -->
<template>
    <div
        class="three-player"
        :class="{nonBottom:mode !== 'tunnel'}"
    >
        <div class="playerBody">
            <v-touch
                tag="div"
                class="playBtns"
                @pinch.prevent="invalidPinch"
            >
                <div v-if="mode === 'atBat'">
                    <v-touch
                        v-if="!playing"
                        tag="p"
                        class="icon-slow playerBtn"
                        @tap="singleSlow()"
                    />
                    <p
                        v-else
                        class="icon-slow playerBtn playing"
                    />
                </div>
                <div v-else>
                    <v-touch
                        v-if="!playing"
                        tag="p"
                        class="icon-slow playerBtn"
                        @tap="multiSlow()"
                    />
                    <p
                        v-else
                        class="icon-slow playerBtn playing"
                    />
                </div>
                <div v-if="mode === 'atBat'">
                    <v-touch
                        v-if="!playing"
                        tag="p"
                        class="icon-play playerBtn"
                        @tap="singlePitch()"
                    />
                    <p
                        v-else
                        class="icon-play playerBtn playing"
                    />
                </div>
                <div v-else>
                    <v-touch
                        v-if="!playing"
                        tag="p"
                        class="icon-play playerBtn"
                        @tap="multiPitch()"
                    />
                    <p
                        v-else
                        class="icon-play playerBtn playing"
                    />
                </div>
            </v-touch>
            <!--
            <input id="range" type="range" min="0" :max="nowMaxFrame" step="1" :value="nowFrame"
                   data-orientation="vertical" @input="rangeInput()">
                   -->
            <RangeSlider
                v-model.number="localNowFrame"
                :min="0"
                :max="nowMaxFrame"
            />
            <div
                class="seekBar"
                :style="'width:' + localNowFrame / nowMaxFrame * 320 +'px'"
            />

            <div
                v-if="mode === 'atBat'"
                class="prevNext"
            >
                <v-touch
                    v-if="!playing && nowID > 0"
                    tag="p"
                    class="icon-skip-prev playerBtn"
                    @tap="prev"
                />
                <p
                    v-else
                    class="icon-skip-prev playerBtn playing"
                />
                <p class="ballNo">
                    {{ nowID + 1 }} | {{ allBallsLength }} 球目
                </p>
                <v-touch
                    v-if="!playing && nowID < allBallsLength - 1"
                    tag="p"
                    class="icon-skip-next playerBtn"
                    @tap="next"
                />
                <p
                    v-else
                    class="icon-skip-next playerBtn playing"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Common3dPlayer from '@/components_common/3d/Player.vue'
import RangeSlider from "@/components_common/3d/RangeSlider.vue"

export default {
    name: 'ThreePlayer',
    components: {RangeSlider},
    mixins: [Common3dPlayer],
    emits: ['range-input'],
}
</script>

<style scoped>
.three-player {
    position: absolute;
    bottom: 27px;
    left: 0;
    width: 100%;
    height: 55px;
    background: rgba(34, 34, 34, 0.75);
}

.nonBottom {
    bottom: 0;
}

.playerBody {
    width: 100%;
    height: 55px;
}

.playerBtn {
    color: #fff;
    font-size: 32px;
    width: 32px;
    height: 32px;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.playBtns,
.prevNext {
    position: absolute;
    top: 0;
    display: flex;
}

.playBtns {
    left: calc(50% - 254px);
}

.prevNext {
    left: calc(50% + 175px);
}

.playerBtn.icon-slow {
    position: relative;
    top: 11px;
    margin-right: 15px;
}

.playerBtn.icon-play {
    position: relative;
    top: 11px;
}

.playerBtn.playing {
    color: #999;
}

.playerBtn.icon-skip-prev {
    position: relative;
    top: 11px;
    margin-right: 15px;
}

.playerBtn.icon-skip-next {
    position: relative;
    top: 11px;
    margin-left: 15px;
}

.seekBar {
    position: absolute;
    width: 320px;
    height: 5px;
    background: rgba(255, 255, 255, 1);
    top: 25px;
    left: calc(50% - 160px);
}

.ballNo {
    color: #fff;
    font-size: 12px;
    line-height: 55px;
}
</style>
